import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  AppUpdateDetectionService,
  LoaderService,
  StorageService
} from 'sigv-library';
import { version } from 'src/environments/version';
import { environment } from './../environments/environment';
import { ElementControlService } from './core/services/element-control.service';
import { EnvironmentService } from './core/services/environment.service';
import { RouterHistoryService } from './core/services/router-history.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  ENVIRONMENT = 'assets/env/environment.json';
  PLUGIN_ELEMENT_CONTROL_CONFIG_URL = 'assets/env/element-control.json';

  title = environment.isExtranet ? 'E-Websubmission' : 'Websubmission';
  isLoading = false;
  version = version.revision;
  branch = version.branch;
  updatedDate = version.updatedDate;
  private readonly destroy$ = new Subject();
  constructor(
    private http: HttpClient,
    private titleService: Title,
    private loaderService: LoaderService,
    private primengConfig: PrimeNGConfig,
    private translateService: TranslateService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private appUpdateDetectionService: AppUpdateDetectionService,
    private routerHistoryService: RouterHistoryService,
    private elementControlService:ElementControlService,
  ) {}

  ngOnInit(): void {
    this.http.get(this.PLUGIN_ELEMENT_CONTROL_CONFIG_URL).subscribe((data) => {
      ElementControlService.elementControlConfig = data;
      this.elementControlService.getElementControlJSON$.next(data);
    });

    this.http.get(this.ENVIRONMENT).subscribe((data) => {
      EnvironmentService.environmentConfig = data;
    });

    this.primengConfig.ripple = true;

    this.titleService.setTitle(this.title);

    // 外部模組可帶入語系(參數名稱 lang)，變換系統語系
    const queryParams = this.route.snapshot.queryParams;
    const paramLang = queryParams.lang;

    if (paramLang && ['en', 'zh-tw'].includes(paramLang)) {
      this.translateService.setDefaultLang(paramLang);
      this.translateService.use(paramLang);
      this.storageService.lang.setItem(paramLang);
    } else {
      const saveLang = this.storageService.lang.getItem();
      this.translateService.setDefaultLang(saveLang || 'en');
      this.translateService.use(saveLang || 'en');
    }

    this.loaderService.loading$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: boolean) => {
        if (status != this.isLoading)
        {
          this.isLoading = status;
          this.changeDetectorRef.detectChanges();
        }
      });

  }

  ngAfterViewInit(): void {
    if (this.appUpdateDetectionService.isEnabled) {
      this.appUpdateDetectionService.checkForUpdates();
      this.appUpdateDetectionService.versionSubject.subscribe({
        next: () => {
          this.appUpdateDetectionService.loadNewAppVersion();
        },
      });
    }
    this.routerHistoryService.initWatch();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
